export enum UnitCategory {
  Length = 'length',
  Area = 'area',
  Volume = 'volume',

  Mass = 'mass',
  Amount = 'amount',
  Frequency = 'frequency',
  Duration = 'duration',
  Temperature = 'temperature',

  // Electric
  ElectricPotential = 'electric potential',
  ElectricResistance = 'electric resistance',
  ElectricConductance = 'electric conductance',
  ElectricInductance = 'electric inductance',
  ElectricCharge = 'electric charge',
  ElectricCurrent = 'electric current',

  Energy = 'energy',
  Power = 'power',
  Force = 'force',
  Pressure = 'pressure',

  Light = 'light',
  Angle = 'angle',
  Time = 'time',

  CurrencySEK = 'currency_SEK',
  CurrencyUSD = 'currency_USD',
  CurrencyEUR = 'currency_EUR',

  CO2e = 'CO2e',
}

export enum UnitSystem {
  Metric = 'Metric',
  Imperial = 'Imperial',
  USCustomary = 'US Customary',
}
